import { AsyncStatus } from 'lib-shared-legacy-types';

import { websocketActions } from '../../../../app/middleware/websocket/actions/websocket';
type GetSucceeded = {
  type: 'ORGANIZATION_GET_SUCCEEDED';
  profile: any;
};

type UploadedAvatarSucceeded = {
  type: 'ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED';
  url: string;
};

type ChangeDefaultNumber = {
  type: 'ORGANIZATION_CHANGE_DEFAULT_NUMBER';
  defaultNumber: string;
};

export type OrganizationAction =
  | GetSucceeded
  | UploadedAvatarSucceeded
  | ChangeDefaultNumber;

export type OrganizationState = {
  meta: {
    asyncStatus: AsyncStatus;
    featureflagsAsyncStatus: AsyncStatus;
    hasUnsavedChanges: boolean;
  };
  organization: {
    name: string;
    avatar_url: string;
    id: string;
    created_at: string;
    trial_ended_at: string | null;
    subdomain: string;
    suspended: boolean;
    default_queue: string;
    default_outbound_number: string | null;
    elevio_workspace_id?: string | null; // currently not returned via `websocketActions.createFulfilled.type`
    timezone?: string | null;
  };
  featureflags: {
    is_listen_in_allowed: boolean;
    is_callrecording_allowed: boolean;
  };
};

const initialState: OrganizationState = {
  meta: {
    asyncStatus: 'succeeded',
    featureflagsAsyncStatus: 'succeeded',
    hasUnsavedChanges: false,
  },
  organization: {
    name: '',
    avatar_url: '',
    id: '',
    created_at: '',
    trial_ended_at: null,
    subdomain: '',
    suspended: false,
    default_queue: '',
    default_outbound_number: null,
    elevio_workspace_id: null,
  },
  featureflags: {
    is_listen_in_allowed: true,
    is_callrecording_allowed: true,
  },
};

export function organization(
  state: OrganizationState = initialState,
  action: any,
): OrganizationState {
  switch (action.type) {
    case websocketActions.createFulfilled.type:
      return { ...state, organization: action.payload.params.organization };

    case 'ORGANIZATION_GET_SUCCEEDED':
      return {
        ...state,
        organization: action.organization,
        meta: { ...state.meta, asyncStatus: 'succeeded' },
      };

    case 'ORGANIZATION_GET_FAILED':
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };

    case 'ORGANIZATION_GET_FEATURE_FLAGS':
      return {
        ...state,
        meta: { ...state.meta, featureflagsAsyncStatus: 'loading' },
      };

    case 'ORGANIZATION_GET_FEATURE_FLAGS_SUCCEEDED':
      return {
        ...state,
        meta: { ...state.meta, featureflagsAsyncStatus: 'succeeded' },
        featureflags: Object.assign(
          {},
          action.featureflags ? action.featureflags : state.featureflags,
        ),
      };

    case 'ORGANIZATION_GET_FEATURE_FLAGS_FAILED':
      return {
        ...state,
        meta: { ...state.meta, featureflagsAsyncStatus: 'failed' },
      };

    case 'ORGANIZATION_EDIT':
    case 'ORGANIZATION_GET_PRESIGNED':
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };

    case 'ORGANIZATION_EDIT_SUCCEEDED':
      return {
        ...state,
        organization: { ...state.organization, ...action.organization },
        meta: {
          ...state.meta,
          asyncStatus: 'succeeded',
          hasUnsavedChanges: false,
        },
      };

    case 'ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED':
      return {
        ...state,
        organization: {
          ...state.organization,
          avatar_url: action.payload.updates.avatar_url,
        },
      };

    case 'ORGANIZATION_EDIT_FAILED':
    case 'ORGANIZATION_UPLOAD_AVATAR_FAILED':
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };

    case 'ORGANIZATION_CHANGE_DEFAULT_NUMBER':
      return {
        ...state,
        organization: {
          ...state.organization,
          default_outbound_number: action.defaultNumber,
        },
        meta: { ...state.meta, hasUnsavedChanges: true },
      };

    default:
      return state;
  }
}
